import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

export interface Credentials {
  data: object;
  username: string;
  token: string;
}

export interface ErrorLogin {
  message: string;
  type: string;
}

export interface LoginContext {
  Usuario: string;
  Password: string;
  grant_type: string;
}

const credentialsKey = 'credentials';
const recoveryKey = 'recovery';

@Injectable()
export class AuthenticationService {
  private _credentials: Credentials | null;
  private _recovery: boolean;

  constructor(private http: HttpClient) {
    const savedCredentials = sessionStorage.getItem(credentialsKey) || localStorage.getItem(credentialsKey);
    if (savedCredentials) {
      this._credentials = JSON.parse(savedCredentials);
    }

    this._recovery = false;
  }


  serviceLogin(context: LoginContext): Observable<any> {
    const body = {
      Password: context.Password,
      Usuario: context.Usuario 
    }
    const headers = new HttpHeaders().set('Accept', 'application/json') 
    headers.set('Content-Type', 'application/json');

    return this.http.post(environment.serverUrl + '/auth/login', body, {
      headers: headers
    });
  }

  async login(context: LoginContext) {

    try{
      let response = await this.serviceLogin(context).toPromise();
      console.log(response);
      if(response) {
        const credentials = {
          username: context.Usuario,
          data: response.data,
          token: 'Bearer ' + response.token
        };
        if(response.data.Divisiones.length == 1) {
          localStorage.setItem('division', JSON.stringify(response.data.Divisiones[0]));
        }
        this.setCredentials(credentials, true);
        return of(credentials);
      }else {
        return of(response);
      }
    } catch (err) {
      console.log(err);
      return of(err.error);
    }


    /*return await this.http
      .post(environment.serverUrl + '/auth/login', body, {
        headers: headers
      })
      .pipe(
        map((response: any) => {
          console.log(response);
          if(response) {
            const credentials = {
              username: context.Usuario,
              data: response.data,
              token: 'Bearer ' + response.token
            };
            if(response.data.Divisiones.length == 1) {
              localStorage.setItem('division', JSON.stringify(response.data.Divisiones[0]));
            }
            this.setCredentials(credentials, true);
            return of(credentials);
          }else {
            return of(response);
          }

        }),
        catchError(err => {
          console.log(err);
          return of(err.error);
        })
      );*/
  }
/*
  async registerUser(user: any) {
    const headers = new HttpHeaders().set('Accept', 'application/json') 
    headers.set('Content-Type', 'application/json');
    return await this.http.post(environment.serverUrl + '/auth/registrarUsuario', user, {
      headers: headers
    }).toPromise();

  }
  */
  
  registerUser(newUser: any): Observable<any> {
    return this.http.post(environment.serverUrl + '/api/Users', newUser);
  }

  isRecovery(): boolean {
    if (sessionStorage.getItem(recoveryKey) != null) {
      this._recovery = true;
      sessionStorage.removeItem(recoveryKey);
      return this._recovery;
    } else {
      return false;
    }
  }

  setRecovery(recovery: boolean) {
    if (recovery) {
      const storage = sessionStorage;
      storage.setItem(recoveryKey, JSON.stringify(recovery));
    } else {
      sessionStorage.removeItem(recoveryKey);
    }
  }

  logout(): Observable<boolean> {
    this.setCredentials();
    return of(true);
  }

  isAuthenticated(): boolean {
    return !!this.credentials;
  }

  get credentials(): Credentials | null {
    return this._credentials;
  }

  getToken(context: any): Observable<any> {
    const body = {
      email: context.username,
      password: context.password,
      id: 0,
      activacion: true
    }
    const headers = new HttpHeaders().set('Accept', 'application/json') 
    headers.set('Content-Type', 'application/json');
    return this.http.put(environment.serverUrl + '/auth/refresh', body, {  
      headers: headers 
    });
  }

  private setCredentials(credentials?: Credentials, remember?: boolean) {
    this._credentials = credentials || null;
    if (credentials) {
      const storage = remember ? localStorage : sessionStorage;
      storage.setItem(credentialsKey, JSON.stringify(credentials));
    } else {
      sessionStorage.removeItem(credentialsKey);
      localStorage.removeItem(credentialsKey);
    }
  }
}
